export default "__VITE_ASSET__DmhheYMe__"